import { render, staticRenderFns } from "./ProductImg.vue?vue&type=template&id=2349dc74&scoped=true&"
import script from "./ProductImg.vue?vue&type=script&lang=js&"
export * from "./ProductImg.vue?vue&type=script&lang=js&"
import style0 from "./ProductImg.vue?vue&type=style&index=0&id=2349dc74&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2349dc74",
  null
  
)

export default component.exports